import { createSelector } from 'reselect';

const isEditingNote = state => state.notes.isEditingNote;
const list = state => state.notes.list;

const editingNote = createSelector(
  [list, isEditingNote],
  (notes, noteGuid) => {
    const selected = !notes ? null : notes.find(note => note.guid === noteGuid);
    return !selected ? null : selected;
  },
);

export default { editingNote };
